/* eslint-disable no-case-declarations */

import {
  LOADING_USERS,
  LOADING_USERS_SUCCESS,
  LOADING_USERS_ERROR,

  ADDING_USER,
  ADDING_USER_SUCCESS,
  ADDING_USER_ERROR,

  UPDATING_USER,
  UPDATING_USER_SUCCESS,
  UPDATING_USER_ERROR,

  DELETING_USER,
  DELETING_USER_SUCCESS,
  DELETING_USER_ERROR,

  FINDING_USER,
  FINDING_USER_SUCCESS,
  FINDING_USER_ERROR,




  LOADING_AREAS,
  LOADING_AREAS_SUCCESS,
  LOADING_AREAS_ERROR,

  ADDING_AREA,
  ADDING_AREA_SUCCESS,
  ADDING_AREA_ERROR,

  UPDATING_AREA,
  UPDATING_AREA_SUCCESS,
  UPDATING_AREA_ERROR,

  DELETING_AREA,
  DELETING_AREA_SUCCESS,
  DELETING_AREA_ERROR,

  FINDING_AREA,
  FINDING_AREA_SUCCESS,
  FINDING_AREA_ERROR,





  LOADING_GROUPS,
  LOADING_GROUPS_SUCCESS,
  LOADING_GROUPS_ERROR,

  ADDING_GROUP,
  ADDING_GROUP_SUCCESS,
  ADDING_GROUP_ERROR,

  UPDATING_GROUP,
  UPDATING_GROUP_SUCCESS,
  UPDATING_GROUP_ERROR,

  DELETING_GROUP,
  DELETING_GROUP_SUCCESS,
  DELETING_GROUP_ERROR,

  FINDING_GROUP,
  FINDING_GROUP_SUCCESS,
  FINDING_GROUP_ERROR,



  LOADING_RULES,
  LOADING_RULES_SUCCESS,
  LOADING_RULES_ERROR,

  ADDING_RULE,
  ADDING_RULE_SUCCESS,
  ADDING_RULE_ERROR,

  UPDATING_RULE,
  UPDATING_RULE_SUCCESS,
  UPDATING_RULE_ERROR,

  DELETING_RULE,
  DELETING_RULE_SUCCESS,
  DELETING_RULE_ERROR,

} from '../actions/manage';

const initialState = {
  userList: [],
  areaList: [],
  reged_areaList: [],
  groupList: [],
  ruleList: [],
  manage_total: 0,
  loading: false,
  find_manage_loading: false,
};
  
const ManageReducer = (state = initialState, action) => {
    switch (action.type) {
      case LOADING_USERS:
        return { ...state, loading: true };
  
      case LOADING_USERS_SUCCESS:
        return {
          ...state,
          loading: false,
          userList: action.payload,
        };

      case ADDING_USER:
        return { ...state, loading: true };
  
      case ADDING_USER_SUCCESS:
        return {
          ...state,
          loading: false,
          //userList: [...state.userList, action.payload],
          userList: [action.payload],
          manage_total: 1,
        };

      case UPDATING_USER:
        return { ...state, loading: true };
  
      case UPDATING_USER_SUCCESS:
        return {
          ...state,
          loading: false,
          userList: [...state.userList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_USER:
        return { ...state, loading: true };
  
      case DELETING_USER_SUCCESS:
        return {
          ...state,
          loading: false,
          userList: [...state.userList.filter((obj) => {
            const findObj = action.payload.find(removedUser => (removedUser.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case FINDING_USER:
        return { ...state, find_manage_loading: true };
  
      case FINDING_USER_SUCCESS:
        return {
          ...state,
          find_manage_loading: false,
          manage_total: action.payload.find_total,
          userList: action.payload.find_users,
        };

      
        
      case LOADING_AREAS:
        return { ...state, find_manage_loading: true };
  
      case LOADING_AREAS_SUCCESS:
        return {
          ...state,
          find_manage_loading: false,
          reged_areaList: action.payload,
        };

      case ADDING_AREA:
        return { ...state, loading: true };
  
      case ADDING_AREA_SUCCESS:
        return {
          ...state,
          loading: false,
          //areaList: [...state.areaList, action.payload],
          areaList: [action.payload],
          manage_total: 1,
        };

      case UPDATING_AREA:
        return { ...state, loading: true };
  
      case UPDATING_AREA_SUCCESS:
        return {
          ...state,
          loading: false,
          areaList: [...state.areaList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_AREA:
        return { ...state, loading: true };
  
      case DELETING_AREA_SUCCESS:
        return {
          ...state,
          loading: false,
          areaList: [...state.areaList.filter((obj) => {
            const findObj = action.payload.find(removedArea => (removedArea.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };

      case FINDING_AREA:
        return { ...state, find_manage_loading: true };
  
      case FINDING_AREA_SUCCESS:
        return {
          ...state,
          find_manage_loading: false,
          manage_total: action.payload.find_total,
          areaList: action.payload.find_areas,
        };





        case LOADING_GROUPS:
          return { ...state, loading: true };
    
        case LOADING_GROUPS_SUCCESS:
          return {
            ...state,
            loading: false,
            groupList: action.payload,
          };
  
        case ADDING_GROUP:
          return { ...state, loading: true };
    
        case ADDING_GROUP_SUCCESS:
          return {
            ...state,
            loading: false,
            //groupList: [...state.groupList, action.payload],
            groupList: [action.payload],
            manage_total: 1,
          };
  
        case UPDATING_GROUP:
          return { ...state, loading: true };
    
        case UPDATING_GROUP_SUCCESS:
          return {
            ...state,
            loading: false,
            groupList: [...state.groupList.map((obj) => {
              return action.payload.id === obj.id ? action.payload : obj;
            })]
          };
  
        case DELETING_GROUP:
          return { ...state, loading: true };
    
        case DELETING_GROUP_SUCCESS:
          return {
            ...state,
            loading: false,
            groupList: [...state.groupList.filter((obj) => {
              const findObj = action.payload.find(removedGroup => (removedGroup.id === obj.id));
              if (findObj === undefined)
                return true;
              return (obj.id !== findObj.id);
            })],
          };

        case FINDING_GROUP:
          return { ...state, find_manage_loading: true };
    
        case FINDING_GROUP_SUCCESS:
          return {
            ...state,
            find_manage_loading: false,
            manage_total: action.payload.find_total,
            groupList: action.payload.find_groups,
          };

      case LOADING_RULES:
        return { ...state, loading: true };
  
      case LOADING_RULES_SUCCESS:
        return {
          ...state,
          loading: false,
          ruleList: action.payload,
        };

      case ADDING_RULE:
        return { ...state, loading: true };
  
      case ADDING_RULE_SUCCESS:
        return {
          ...state,
          loading: false,
          ruleList: [...state.ruleList, action.payload],
        };

      case UPDATING_RULE:
        return { ...state, loading: true };
  
      case UPDATING_RULE_SUCCESS:
        return {
          ...state,
          loading: false,
          ruleList: [...state.ruleList.map((obj) => {
            return action.payload.id === obj.id ? action.payload : obj;
          })]
        };

      case DELETING_RULE:
        return { ...state, loading: true };
  
      case DELETING_RULE_SUCCESS:
        return {
          ...state,
          loading: false,
          ruleList: [...state.ruleList.filter((obj) => {
            const findObj = action.payload.find(removedRule => (removedRule.id === obj.id));
            if (findObj === undefined)
              return true;
            return (obj.id !== findObj.id);
          })],
        };
      default:
        return state;
    }
  };
  
  export default ManageReducer;
  